<template>
  <div class="pdf-preview-page">
    <div class="pdf-preview-header">
      <a-button @click="goBack" type="link" class="back-btn">
        <a-icon type="arrow-left" /> 返回
      </a-button>
      <span class="pdf-title">{{ title }}</span>
    </div>
    <div class="pdf-preview-body">
      <PdfPreview :url="url" />
    </div>
  </div>
</template>

<script>
import PdfPreview from '@/components/pdf-preview'

export default {
  name: 'PdfPreviewPage',
  components: { PdfPreview },
  data() {
    return {
      url: '',
      title: 'PDF预览',
    }
  },
  created() {
    this.url = this.$route.query.url || ''
    this.title = this.$route.query.title || 'PDF预览'
    if (!this.url) {
      this.$message.error('缺少PDF文件地址')
      this.$router.back()
    }
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        window.close()
      }
    },
  },
}
</script>

<style lang="less" scoped>
.pdf-preview-page {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background: #fff;
  display: flex;
  flex-direction: column;
}
.pdf-preview-header {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-bottom: 1px solid #e8e8e8;
  background: #fafafa;
  flex-shrink: 0;
}
.back-btn {
  font-size: 14px;
  margin-right: 12px;
}
.pdf-title {
  font-size: 16px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pdf-preview-body {
  flex: 1;
  overflow: hidden;
}
</style>
